














































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

const DEFAULT_DATE = "";
@Component({
  model: {
    prop: "value",
    event: "input",
  },
  watch: {
    value: "setValue",
  },
})
export default class DatePicker extends Vue {
  @Prop({ default: () => true })
  readonly showPI: boolean;

  @Prop()
  readonly value: string;

  @Prop({ default: false })
  readonly outlined: boolean;

  @Prop({ default: null })
  readonly label: string;

  @Prop({ default: "" })
  readonly placeholder: string;

  @Prop({ default: false })
  readonly clearable: boolean;

  @Prop({ default: null })
  readonly min: string;

  @Prop({ default: null })
  readonly max: string;

  @Prop({ default: () => [] })
  readonly rules: any;

  @Prop({ default: false })
  readonly dense: boolean;

  @Prop({ default: false })
  readonly hideDetails: boolean;

  display = false;
  date = "";

  get formattedDate() {
    if (!this.value) return null;
    return moment(this.value, "YYYY-MM-DD").format("DD.MM.YYYY");
  }

  okHandler() {
    this.resetPicker();
    this.$emit("input", this.date);
  }
  resetPicker() {
    this.display = false;
  }
  clearHandler() {
    this.resetPicker();
    this.date = DEFAULT_DATE;
    this.$emit("input", undefined);
  }
  setValue(date: string) {
    this.date = date;
  }

  getTitleDateFormat(isoDate: string) {
    moment.locale(this.isKz ? "kk-KZ" : "ru-Ru");
    const weekDay = moment(new Date(isoDate)).format("dddd").substring(0,3);
    const monthName = moment(new Date(isoDate)).format("MMMM").substring(0,3);
    const day = moment(new Date(isoDate)).format("D");
    return `${weekDay}, ${day} ${monthName}. `;
  }

  getDayFormat(isoDate: string) {
    return Number.parseInt(isoDate.substr(8, 2));
  }

  getMonthFormat(isoDate: string) {
    moment.locale(this.isKz ? "kk-KZ" : "ru-Ru");
    return moment(isoDate.substr(5), "M").format("MMMM");
  }
  getHeaderDateFormat(isoDate: string) {
    moment.locale(this.isKz ? "kk-KZ" : "ru-Ru");
    const month =
      isoDate.length > 4 ? moment(isoDate.substr(5), "M").format("MMMM") : "";
    const res = this.isKz
      ? isoDate.substr(0, 4) + " ж. " + month
      : month + " " + isoDate.substr(0, 4) + " г.";
    return res;
  }
  getWeekDayFormat(isoDate: string) {
    moment.locale(this.isKz ? "kk-KZ" : "ru-Ru");
    const weekDay = moment(new Date(isoDate)).format("dddd");
    return this.isKz ? `${weekDay.substring(0, 3)}.` : weekDay.substring(0, 1);
  }
  get isKz() {
    return this.$i18n.locale === "kk";
  }
}
